import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AddIcon from "@mui/icons-material/Add";

import { toast, Toaster } from "react-hot-toast";
import { colors } from "../../../Shared/colors";
import { useGetAllRegionQuery } from "../../../features/regionSlice";
import { useCreateProjectMutation } from "../../../features/projectSlice";

export const ProjectsFirst = () => {
  const [popUp, setpopUp] = useState(false);
  const [enableBlocks, setEnableBlocks] = useState(false);

  const [projectBlock, setProjectBlock] = useState([]);
  const [projectBlockObj, setProjectBlockObj] = useState({
    blockName: "",
    blockType: "",
  });
  const [Project, setProject] = useState({
    projectName: "",
    projectType: "",
    region: "",
    location: "",
    projectBlock: [],
  });

  useEffect(() => {
    setProject((prevState) => ({
      ...prevState,
      projectBlock: projectBlock,
    }));
  }, [projectBlock]);



  let { data: region } = useGetAllRegionQuery();

  let [addProject, { isLoading }] = useCreateProjectMutation()


  const handleProjectBlock = () => {
    const blockName = projectBlockObj.blockName.trim();
    const blockType = projectBlockObj.blockType.trim();

    if (!blockName || !blockType) {
      toast.error("Block name and block type are required");
      return;
    }

      const updatedProjectBlock = [
        ...projectBlock,
        {
        blockName,
        blockType,
        },
      ];
      setProject((prevState) => ({
        ...prevState,
        projectBlock: updatedProjectBlock,
      }));
      setProjectBlock(updatedProjectBlock);
      setProjectBlockObj({
        blockName: "",
        blockType: "",
      });
  };


  let projectType = [
    "vaccant land",
    "residential",
    "commercial",
    "industrial",
    "agricultural",
    "residential/commercial",
    "apartment",
    "home",
    "plot",
  ];


  const handleProjectBlockObj = (e) => {
    const { name, value } = e.target;
    setProjectBlockObj({
      ...projectBlockObj,
      [name]: value,
    });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "blockName" || name === "blockType") {
  //     setProject((prevState) => ({
  //       ...prevState,
  //       projectBlock: {
  //         ...prevState.projectBlock,
  //         [name]: value,
  //       },
  //     }));
  //   } else {
  //     setProject((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProject((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleSave = async () => {
    const trimmedProject = {
      projectName: Project.projectName.trim(),
      projectType: Project.projectType.trim(),
      region: Project.region,
      location: Project.location.trim(),
    };

    if (!trimmedProject.projectName || !trimmedProject.projectType || !trimmedProject.region || !trimmedProject.location) {
      toast.error("Project name, type, region and location are required");
      return;
    }

    if ((projectBlockObj.blockName && !projectBlockObj.blockType) || (!projectBlockObj.blockName && projectBlockObj.blockType)) {
      toast.error("Please fill both Block Name and Block Type");
      return;
    }

    let finalProjectBlock = [...projectBlock];

    if (projectBlockObj.blockName.trim() && projectBlockObj.blockType.trim()) {
      finalProjectBlock.push({
        blockName: projectBlockObj.blockName.trim(),
        blockType: projectBlockObj.blockType.trim(),
      });
    }

    const projectData = {
      ...trimmedProject,
      projectBlock: finalProjectBlock,
    };

    try {
      await addProject(projectData).unwrap();
      toast.success("Project added successfully");

      setProject({
        projectName: "",
        projectType: "",
        region: "",
        location: "",
        projectBlock: [],
      });
      setProjectBlock([]);
      setProjectBlockObj({ blockName: "", blockType: "" });
      setEnableBlocks(false);
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.data?.error?.message || "Something went wrong");
    }
  };


  return (
    <Main>
      <Search>
        <AffiliateSection>
          <SubHeading>Add Project</SubHeading>
        </AffiliateSection>
        <SearchSection1>
          <InputSection>
            <h3>Name:</h3>
            <input type="text" name="projectName" value={Project.projectName} onChange={handleChange} />
          </InputSection>
          <InputSection>
            <h3>Type:</h3>
            <div>
              <select
                name="projectType"
                id="projectType"
                onChange={handleChange}
                value={Project.projectType}
              >
                <option value="">Select</option>
                {projectType.map((ls) => (
                  <option value={ls}>{ls}</option>
                ))}
              </select>
            </div>
          </InputSection>
          <InputSection>
            <h3>Region:</h3>
            <div>
              <select name="region" id="region" onChange={handleChange} value={Project.region}>
                <option value="">select</option>
                {region?.map((ls) => (
                  <option value={ls._id}>{ls.regionName}</option>
                ))}
              </select>
            </div>
          </InputSection>
        </SearchSection1>
        <SearchSection2>
          <InputSection>
            <h3>Location:</h3>
            <input type="text" name="location" onChange={handleChange} value={Project.location} />
          </InputSection>
          
          {/* Project Blocks Toggle Section */}
          <BlocksToggleSection>
            <ToggleContainer>
              <ToggleLabel>
                <ToggleSwitch>
                  <input
                    type="checkbox"
                    checked={enableBlocks}
                    onChange={(e) => {
                      setEnableBlocks(e.target.checked);
                      if (!e.target.checked) {
                        // Clear blocks when disabled
                        setProjectBlock([]);
                        setProjectBlockObj({ blockName: "", blockType: "" });
                      }
                    }}
                  />
                  <ToggleSlider />
                </ToggleSwitch>
                <ToggleText>Add Project Blocks (Optional)</ToggleText>
              </ToggleLabel>
            </ToggleContainer>
          </BlocksToggleSection>

          {/* Conditionally show block input fields */}
          {enableBlocks && (
            <BlocksSection>
              <BlocksHeader>
                <BlocksTitle>Project Blocks</BlocksTitle>
                <BlocksSubtitle>Add blocks to organize your project</BlocksSubtitle>
              </BlocksHeader>
              
              <BlocksInputRow>
          <InputSection>
            <h3>Block Name:</h3>
            <input
              type="text"
              name="blockName"
                    placeholder="e.g., Block A, Phase 1"
              value={projectBlockObj.blockName}
              onChange={handleProjectBlockObj}
            />
          </InputSection>
          <InputSection>
            <h3>Block Type:</h3>
            <input
              type="text"
              name="blockType"
                    placeholder="e.g., Residential, Commercial"
              value={projectBlockObj.blockType}
              onChange={handleProjectBlockObj}
            />
          </InputSection>
                <AddBlockButton onClick={handleProjectBlock} disabled={!projectBlockObj.blockName.trim() || !projectBlockObj.blockType.trim()}>
                  <AddIcon style={{ fontSize: '1.2rem' }} />
                  Add Block
                </AddBlockButton>
              </BlocksInputRow>

              {/* Display added blocks */}
              {projectBlock.length > 0 && (
                <BlockList>
                  <BlocksListTitle>Added Blocks ({projectBlock.length}):</BlocksListTitle>
                  <BlocksChipsContainer>
                    {projectBlock.map((block, idx) => (
                      <BlockChip key={`${block.blockName}-${idx}`}>
                        <BlockChipContent>
                          <BlockChipName>{block.blockName}</BlockChipName>
                          <BlockChipType>{block.blockType}</BlockChipType>
                        </BlockChipContent>
                        <RemoveBlockButton
                          onClick={() => {
                            const updated = projectBlock.filter((_, i) => i !== idx);
                            setProjectBlock(updated);
                            setProject((prev) => ({ ...prev, projectBlock: updated }));
                          }}
                        >
                          ×
                        </RemoveBlockButton>
                      </BlockChip>
                    ))}
                  </BlocksChipsContainer>
                </BlockList>
              )}
            </BlocksSection>
          )}

          <Button onClick={handleSave} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner /> Adding...
              </>
            ) : (
              <>Add Project</>
            )}
          </Button>
        </SearchSection2>
      </Search>
      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  width: 90%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-height: 30vh;
  margin: 0 auto;
`;

const AffiliateSection = styled.div`
  width: 100%;
  color: ${colors.text};
  border-bottom: 1px solid ${colors.inputBorderWhite};
  padding-bottom: 1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Search = styled.div`
  background-color: ${colors.white};
  width: 100%;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  min-height: 19em;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem;
`;

const SubHeading = styled.h4`
  font-size: clamp(1.2em, 1.2vw, 1.5em);
`;

const SearchSection1 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
`;

const SearchSection2 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  align-items: end;
`;

const InputSection = styled.div`
  min-width: 2em;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  h3 {
    color: ${colors.black};
    font-size: 0.95rem;
    margin: 0;
    font-weight: 600;
  }
  div {
    position: relative;
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 8px;
    width: 100%;
    background-color: ${colors.white};
    select {
      background-color: ${colors.white};
      width: 100%;
      padding: 0.75rem 1rem;
      outline: none;
      border: none;
      border-radius: 8px;
      font-size: 0.95rem;
      color: ${colors.text};
      ::placeholder {
        color: ${colors.inputFeild};
      }
    }
  }
  input {
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 8px;
    background-color: ${colors.white};
    width: 100%;
    padding: 0.75rem 1rem;
    outline: none;
    font-size: 0.95rem;
    color: ${colors.text};
    ::placeholder {
      color: ${colors.inputFeild};
    }
  }
`;

const Button = styled.button`
  padding: 0.9rem 1.4rem;
  min-width: 8em;
  color: ${colors.white};
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(36, 147, 147, 0.25);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(36, 147, 147, 0.28);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const PopUpContainer = styled.div`
  background-color: #0000004d;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0vh;
  left: 0;
  z-index: 11;
  position: fixed;
  display: ${(porps) => (porps.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
`;

const PopUp = styled.div`
  width: 50%;
  height: 90%;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  overflow: scroll;
`;

const Cross = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 2em;
  img {
    height: 20%;
    object-fit: contain;
    cursor: pointer;
  }
`;

const PopUpSection = styled.form`
  height: calc(100% - 10%);
  display: flex;
  justify-content: space-between;
  position: relative;
`;

const Section = styled.div`
  width: 50%;
  min-height: 100em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Task = styled.div`
  padding: 1em 2em;
  height: 100%;
`;

const InputPart = styled.div`
  h3 {
    font-size: clamp(1.5em, 2vh, 3em);
  }
`;

const InputFeild = styled.div`
  width: 100%;
  h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
  div {
    position: relative;
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 6px;
    width: 100%;
    padding-right: 1em;
    background-color: ${colors.inputWhite};
    select,
    input[type="date"] {
      background-color: ${colors.inputWhite};
      width: 100%;
      padding: 1em 0em 1em 1em;
      outline: none;
      border: none;
      ::placeholder {
        color: ${colors.inputFeild};
      }
    }
  }
  input,
  textarea {
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 6px;
    background-color: ${colors.inputWhite};
    width: 100%;
    padding: 1em 0em 1em 1em;
    outline: none;
    ::placeholder {
      color: ${colors.inputFeild};
    }
  }
  textarea {
    min-height: 11em;
  }
  span {
    background-color: ${colors.inputWhite};
    padding: 1em 0em 1em 1em;
    border-radius: 5px;
    border: 1px solid ${colors.inputBorderWhite};
    display: flex;
    position: relative;
    label {
      position: absolute;
      right: 3%;
      top: 50%;
      transform: translateY(-50%);
      background-color: ${colors.black};
      color: ${colors.white};
      padding: 0.5em 1em;
      border-radius: 5px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      font-size: clamp(1em, 1vh, 2em);
      color: ${colors.textMed};
    }
  }
  input[type="file"] {
    display: none;
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10em;
  button {
    padding: 1em 2em;
    border-radius: 5px;
    outline: none;
    border: none;
    background-color: ${colors.inputWhite};
    cursor: pointer;
  }
`;

const Loader = styled.div`
  margin-top: 1em;
`;

const Plus = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px dashed ${colors.inputBorderWhite};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${colors.white};
  transition: all 0.2s ease;
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
  &:hover {
    border-color: ${colors.brown};
    box-shadow: 0 6px 16px rgba(36, 147, 147, 0.15);
    transform: translateY(-1px);
  }
`;

const BlocksToggleSection = styled.div`
  grid-column: 1 / -1;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border: 1px solid ${colors.inputBorderWhite};
`;

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const ToggleLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  user-select: none;
`;

const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 26px;

  &:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

const ToggleSwitch = styled.div`
  position: relative;
  width: 50px;
  height: 26px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
  }

  input:checked + ${ToggleSlider} {
    background-color: ${colors.brown};
  }

  input:checked + ${ToggleSlider}:before {
    transform: translateX(24px);
  }
`;

const ToggleText = styled.span`
  font-size: 0.95rem;
  font-weight: 500;
  color: ${colors.text};
`;

const BlocksSection = styled.div`
  grid-column: 1 / -1;
  padding: 1.5rem;
  background: ${colors.white};
  border: 2px solid ${colors.brown};
  border-radius: 12px;
  margin-top: 0.5rem;
  animation: slideDown 0.3s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const BlocksHeader = styled.div`
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${colors.inputBorderWhite};
`;

const BlocksTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${colors.text};
  margin: 0 0 0.25rem 0;
`;

const BlocksSubtitle = styled.p`
  font-size: 0.85rem;
  color: ${colors.inputFeild};
  margin: 0;
`;

const BlocksInputRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.25rem;
  align-items: flex-end;
`;

const AddBlockButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  color: ${colors.white};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(36, 147, 147, 0.2);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(36, 147, 147, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const BlockList = styled.div`
  grid-column: 1 / -1;
  margin-top: 1rem;
`;

const BlocksListTitle = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  color: ${colors.text};
  margin: 0 0 0.75rem 0;
`;

const BlocksChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const BlockChip = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid ${colors.brown};
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.15);
  }
`;

const BlockChipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const BlockChipName = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: ${colors.text};
`;

const BlockChipType = styled.small`
  font-size: 0.75rem;
  color: ${colors.inputFeild};
`;

const RemoveBlockButton = styled.button`
  background: transparent;
  border: none;
  color: ${colors.danger || '#dc3545'};
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  line-height: 1;

  &:hover {
    background: rgba(220, 53, 69, 0.1);
    transform: scale(1.1);
  }
`;

const Spinner = styled.div`
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid ${colors.white};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
